import { ReactNode } from 'react';
import { useSearchParams } from 'react-router-dom';
import { subscriptionErrorParamName } from './Login.constants';
import useGetLoginErrorMessage from './useGetLoginErrorMessage';

function wrapErrorMessage(errorMessage: ReactNode | undefined) {
  return (
    <p className="error-message" data-testid="error-message">
      {errorMessage}
    </p>
  );
}

const LoginFormErrorMessageRenderer = ({
  errorMessage,
}: {
  errorMessage: string | undefined;
}) => {
  const [searchParams] = useSearchParams();
  const getSubscriptionErrorMessage = useGetLoginErrorMessage();

  if (errorMessage) {
    return wrapErrorMessage(errorMessage);
  }

  const subscriptionError = searchParams.get(subscriptionErrorParamName);

  if (subscriptionError) {
    const subscriptionDueDays = searchParams.get('sdd');
    const subscriptionManagementLink = searchParams.get('sml') || '';

    const message = getSubscriptionErrorMessage({
      errorCode: subscriptionError,
      subscriptionManagementLink,
      subscriptionPaymentDueDays: subscriptionDueDays
        ? parseInt(subscriptionDueDays, 10)
        : undefined,
    });

    return wrapErrorMessage(message);
  }

  return null;
};

export default LoginFormErrorMessageRenderer;
